import React from 'react';
import { IStorefrontOrder } from '../../../models/Storefront';

interface IStorefrontOrderQuestionsTableProps {
    order: IStorefrontOrder;
}

const StorefrontOrderQuestionsTable: React.FC<IStorefrontOrderQuestionsTableProps> = (props) => {
    if (props.order.questions == null || props.order.questions.length === 0) {
        return <p>No questions and answers available for this order.</p>;
    }
    return (
        <div>
            <table className='data-table'>
                <thead>
                    <tr>
                        <th>Question</th>
                        <th>Answer</th>
                    </tr>
                </thead>
                <tbody>
                    {props.order.questions.map((qa) => (
                        <tr key={`${qa.entityId}-${qa.identifier ?? qa.questionText}`}>
                            <td>{qa.questionText}</td>
                            <td>{qa.answer}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default StorefrontOrderQuestionsTable;